import Vue from "vue";
const vm = new Vue()

export const getCourierById = async (courierId) => {
    return new Promise((resolve, reject) => {
        vm.$http.get( vm.$API_URL + `/shop/superadmin/courier/${courierId}` , {
            headers: {
                Token: localStorage.getItem("access_token")
            }
            }).then( res => {
                if (!res.data.status) {
                    reject(res.data.error.message);
                }
                resolve(res.data.data[0])
            })
    })
}

export const searchShopForRateManagement = async (search) => {
    return new Promise((resolve, reject) => {
        vm.$http.get( vm.$API_URL + `/shop/list/courier` , {
            headers: {
                Token: localStorage.getItem("access_token")
            },
            params: {
                courier_key: search.courierKey,
                default_courier_code: search.rateCode,
                under_by: search.underShop,
                package: search.packageShop,
                shop_code: search.shopCodeArray
            }
            }).then( res => {
                if (!res.data.status) {
                    reject(res.data.error.message);
                }
                resolve(res.data.data)
            })
    })
}

export const createCourierRateManagement = async (selectedShop , rateCode , forceCreate = false) => {
    return new Promise((resolve, reject) => {
        vm.$http.post( vm.$API_URL + '/shop/list/courier', {
                code_shops: selectedShop,
                default_courier_code: rateCode,
                force_create: forceCreate
            },{
                headers: {
                    Token: localStorage.getItem("access_token")
                }
            }
        )
        .then(res => {
            if (!res.data.status) {
                reject(res.data.error.message);
            }
            resolve(res.data)
        })
    })
}
